module.exports = __webpack_public_path__ + "img/4.ab2cba97.jpg";